<template>
  <div>
    <div class="books" v-if="user">
      <book-nav></book-nav>

      <div class="notebooks border border-blue-700 mb-3" v-if="books && books.length > 0">
        <div
            :key="note.id"
            class="flex bg-white font-bold border-b border-blue-700 cursor-pointer"
            v-for="note in books"
        >
          <div class="text-center w-full">
            <router-link
                :data-cy="
                    `book-link-${note.type}${note.encrypt ? '-enc' : ''}`
                  "
                :to="'/admin/notes?book=' + note.id"
                class="text-lg py-4 px-2 block"
            >
              {{ note.title }}
            </router-link>
          </div>
          <div class="text-center border-l">
            <div
                class="text-lg py-4 px-6 block"
                v-on:click="(e) => createNote(e, note.id)"
            >
              +
            </div>
          </div>
        </div>
        <div class="bottom-border border border-blue-700"></div>
      </div>
      <div v-else>You don't have any notebooks, yet.</div>

      <router-link
          :to="'/admin/books/create'"
          class="button-1 inline-block"
          data-cy="create-notebook-link"
      >Create New Notebook
      </router-link>

      <router-link
          :to="$store.state.notes.route"
          class="fixed bottom-0 left-0 p-3 bg-white border"
          v-if="$store.state.notes.route !== '/' && $store.state.notes.route !== null"
      >
        Go to previous
      </router-link>
    </div>
  </div>
</template>

<script>
import BookNav from "./admin/BookNav";

export default {
  components: {
    BookNav,
  },
  computed: {
    books() {
      return this.$store.state.notes.books;
    },
    user() {
      return this.$store.state.notes.user;
    }
  },
  methods: {
    async createNote(book) {
      const noteId = await this.$store.dispatch("aCreateNote", book.id);
      this.$router.push({ path: `/admin/notes/${noteId}/update` });
    }
  },
  created: function() {
    this.$store.dispatch("aGetBooks");
  }
};
</script>
<style lang="scss">
</style>
